import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { prepareValidationForXata } from './common/common_utils';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import ParentCardNoHeader from '../common/ParentCardNoHeader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class XataDatasource extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  handleSendRequset = async (values) => {
    const { xataAPIKey, dataSourceName } = values;
    const { actions, match, history } = this.props;
    const { projectId, version } = match.params;
    const headers = {
      Authorization: `Bearer ${xataAPIKey}`,
    };
    await actions.xataWorkspaceList({ projectId, headers, version });

    if (this.props.dataConnector.workSpaceByXata) {
      history.push(`/data-connector/${version}/v/${projectId}/xata-workspaces`, {
        headers,
        dataSourceName,
      });
    }
  };
  handleCancel = () => {
    const { match, history } = this.props;
    const { projectId, version } = match.params;
    history.push(`/collections/${version}/v/${projectId}/create`);
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }
    const { xataWorkspaceListPending } = this.props.dataConnector;
    return (
      <CommonPageComponent>
        <ParentContentCard title="Create Collection via Xata" datasourceIconSvg="Xata">
          <Formik
            initialValues={{
              dataSourceName: '',
              xataAPIKey: '',
            }}
            validationSchema={prepareValidationForXata}
            onSubmit={this.handleSendRequset}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Name"
                    icon="text"
                    infoIcon={true}
                    infoDescription={
                      'Enter name for the Data Source you want to create in drapcode.'
                    }
                  >
                    <Field
                      type="text"
                      name="dataSourceName"
                      className="form-control form-control-sm"
                      placeholder="Data Source Name"
                    />
                    <ErrorMessage name="dataSourceName" component="p" className="text-danger" />
                  </FormFieldWithLabel>
                </div>

                <ParentCardNoHeader title="Xata Account Details">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="API Key"
                      icon="text"
                      infoIcon={true}
                      infoDescription={
                        'Enter Xata API Key from your Xata account section. This Key is necessary for your application to interact with the Xata backend services. Never share it publicly.'
                      }
                    >
                      <Field
                        type="text"
                        name="xataAPIKey"
                        className="form-control form-control-sm"
                        placeholder="API Key"
                      />
                      <ErrorMessage name="xataAPIKey" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                </ParentCardNoHeader>

                <div className="clearfix">
                  <button
                    className="btn btn-outline-secondary"
                    title="Cancel"
                    type="button"
                    onClick={this.handleCancel}
                  >
                    <i className="wb webconnect-times"></i> Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-theme-submit float-right"
                    disabled={isSubmitting || xataWorkspaceListPending}
                  >
                    <i className="wb webconnect-rocket"></i> &nbsp;Continue&nbsp;
                    <CustomLoader loading={xataWorkspaceListPending}></CustomLoader>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XataDatasource);
